import { useCallback, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import useNhStyleFingerprintSnapshot from '../../hooks/useNhStyleFingerprintSnapshot';
import {
  filterIdentities,
  NO_IDENTITIES_MATCH_MESSAGE,
} from '../../utils/nhStyleFingerprintSnapshot';
import NhStyleFingerprintFilters from './NhStyleFingerprintFilters';
import NhStyleFingerprintOverview from './NhStyleFingerprintOverview';
import NhStyleFingerprintStatus from './NhStyleFingerprintStatus';
import NhStyleFingerprintTable from './NhStyleFingerprintTable';

function NhStyleFingerprintsPage() {
  const { snapshot, loading, error } = useNhStyleFingerprintSnapshot();
  const [nameQuery, setNameQuery] = useState('');
  const [eligibility, setEligibility] = useState('eligible');

  const handleNameChange = useCallback((event) => {
    setNameQuery(event.target.value);
  }, []);

  const handleEligibilityChange = useCallback((_event, nextEligibility) => {
    if (nextEligibility !== null) {
      setEligibility(nextEligibility);
    }
  }, []);

  const filteredIdentities = useMemo(
    () => filterIdentities(snapshot?.identities, { nameQuery, eligibility }),
    [eligibility, nameQuery, snapshot],
  );

  if (loading || error || !snapshot) {
    return (
      <NhStyleFingerprintStatus loading={loading} error={error} snapshot={snapshot} />
    );
  }

  return (
    <Box>
      <NhStyleFingerprintOverview snapshot={snapshot} />
      <NhStyleFingerprintFilters
        nameQuery={nameQuery}
        eligibility={eligibility}
        onNameChange={handleNameChange}
        onEligibilityChange={handleEligibilityChange}
      />
      {filteredIdentities.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {NO_IDENTITIES_MATCH_MESSAGE}
        </Typography>
      ) : (
        <NhStyleFingerprintTable identities={filteredIdentities} />
      )}
    </Box>
  );
}

export default NhStyleFingerprintsPage;
